/**
 * SlidersFactory module
 * @module SlidersFactory
 * @see module: WTM_Libs
 */
define(['wtm_libs', 'swiperLib'], (wtm) => {
    /**
     * SliderFactory class, contains slider creation logic
     * @param {Object} - sliderArgs arguments for the slider object
     * @return {Object} - self
     */
    if (wtm.debug_mode) console.log('> Slider factory starts;');

    wtm.swiperObjects.testSwiper = new Swiper();
    wtm.swiperObjects.arrSwiperParams = Object.keys(wtm.swiperObjects.testSwiper.params);

    return function SliderFactory(sliderArgs) {

        /**
         * Check if instance
         * @param {Object}
         * @return {Object}
         */
        if (!this) {
            return new sliderFactory(sliderArgs);
        }

        var self = this;

        /**
         * Public Variable Slider arguments passed.
         * @type {Object}
         */
        self.sliderArgs = sliderArgs;

        /**
         * Break Point Booleans for custom classes
         * @type {Object}
         */
        self.objBooleanAllSlidesVisible = {};

        /**
         * HTML Collection containing all potential next, prev, and pagination elements.
         * @type {Array}
         */
        var sliderNavigation = [];

        /**
         * Primary building logic
         * @param  {Object} - arguments for the slider object passed from obj def
         * @return {Object} - self
         */
        self.buildSlider = function () {

            let swiperId = self.sliderArgs.target;

            self.sliderArgs.target = "#" + self.sliderArgs.target;

            var swiper = new Swiper(self.sliderArgs.target, self.normalizeArgs());

            self.buildSliderNavigation(swiper);

            wtm.swiperObjects[swiperId] = swiper;
            self.checkCustomClassVisibleSlides();
            self.handleResizeEvent();

            return self;
        };

        /**
         * Filling Navigation Array
         * @return {Object} - self
         */
        self.buildSliderNavigation = function(swiper) {
            sliderNavigation = [
                document.querySelector(swiper.params.prevButton),
                document.querySelector(swiper.params.nextButton),
                document.querySelector(self.sliderArgs.target + " .swiper-pagination")
            ];

            return self;
        };

        /**
         * Primary resize handler
         * @param  {Object} - arguments for the slider object passed from obj def
         * @return {Object} - self
         */
        self.handleResizeEvent = function () {
            window.addEventListener('resize', function () {
                self.resizeSlider(self.sliderArgs);
            });

            return self;
        };

        /**
         * Landing Place for all resize functionality
         * @param  {Object} - arguments for the slider object passed from obj def
         * @return {Object} - self
         */
        self.resizeSlider = function () {
            self.checkCustomClassVisibleSlides(self.sliderArgs);
            return self;
        };

        /**
         * Checks Window Size against custom break point class boolean. Calls set custom if true.
         * @param  {Object} - arguments for the slider object passed from obj def
         * @return {Object} - self
         */
        self.checkCustomClassVisibleSlides = function () {

            this.removeCustomClassVisibleSlides();

            if (window.innerWidth < 768 && self.objBooleanAllSlidesVisible.phone) {
                self.addCustomClassVisibleSlides();
            } else if (window.innerWidth >= 768 && window.innerWidth < 992 && self.objBooleanAllSlidesVisible.smallTablet) {
                self.addCustomClassVisibleSlides();
            } else if (window.innerWidth >= 992 && window.innerWidth < 1200 && self.objBooleanAllSlidesVisible.largeTablet) {
                self.addCustomClassVisibleSlides();
            } else if (window.innerWidth >= 1200 && self.objBooleanAllSlidesVisible.desktop) {
                self.addCustomClassVisibleSlides();
            }

            return self;
        };

        /**
         * Checks custom class to slider if all slides are visible
         * @param  {sliderArgs} - arguments for the slider object passed from obj def
         * @return {Object} - self
         */
        self.addCustomClassVisibleSlides = function () {
            for (var i in sliderNavigation) {
                if (sliderNavigation[i] !== null) {
                    sliderNavigation[i].className = sliderNavigation[i].className + " all-slides-visible";
                }

            }
            return self;
        };

        /**
         * Checks custom class and removes
         * @param  {sliderArgs} - arguments for the slider object passed from obj def
         * @return {Object} - self
         */
        self.removeCustomClassVisibleSlides = function () {
            for (var i in sliderNavigation) {
                if (sliderNavigation[i] !== null) {
                    sliderNavigation[i].classList.remove("all-slides-visible");
                }
            }
            return self;
        };

        /**
         * Primary Takes in sliderArgs and returns arguments appropriate for Swiper
         * Filters out unsused arguments
         * @param  {sliderArgs} - arguments for the slider object passed from obj def
         * @return {Object} - New, cleaned/filtered arguments
         */
        self.normalizeArgs = function () {

            var intRealSlideCount = document.querySelectorAll(self.sliderArgs.target + ' .swiper-wrapper .swiper-slide').length;

            if (intRealSlideCount <= self.sliderArgs.slidesPerViewPhone) {
                self.sliderArgs.slidesPerViewPhone = intRealSlideCount;
                self.objBooleanAllSlidesVisible.phone = true;
            } else {
                self.objBooleanAllSlidesVisible.phone = false;
            }

            if (intRealSlideCount <= self.sliderArgs.slidesPerViewSmallTablet) {
                self.sliderArgs.slidesPerViewSmallTablet = intRealSlideCount;
                self.objBooleanAllSlidesVisible.smallTablet = true;
            } else {
                self.objBooleanAllSlidesVisible.smallTablet = false;
            }

            if (intRealSlideCount <= self.sliderArgs.slidesPerViewLargeTablet) {
                self.sliderArgs.slidesPerViewLargeTablet = intRealSlideCount;
                self.objBooleanAllSlidesVisible.largeTablet = true;
            } else {
                self.objBooleanAllSlidesVisible.largeTablet = false;
            }

            if (intRealSlideCount <= self.sliderArgs.slidesPerViewDesktop) {
                self.sliderArgs.slidesPerViewDesktop = intRealSlideCount;
                self.objBooleanAllSlidesVisible.desktop = true;
            } else {
                self.objBooleanAllSlidesVisible.desktop = false;
            }

            var normalArgs = {
                nextButton: self.sliderArgs.target + ' .swiper-button-next',
                prevButton: self.sliderArgs.target + ' .swiper-button-prev',
                pagination: self.sliderArgs.target + ' .swiper-pagination',
                slidesPerGroup: 1,
                slidesPerView: self.sliderArgs.slidesPerViewDesktop,
                breakpoints: {
                    767: {
                        slidesPerView: self.sliderArgs.slidesPerViewPhone
                    },
                    991: {
                        slidesPerView: self.sliderArgs.slidesPerViewSmallTablet
                    },
                    1200: {
                        slidesPerView: self.sliderArgs.slidesPerViewLargeTablet
                    }
                },
                preventClicks: false
            };

            wtm.swiperObjects.arrSwiperParams.forEach(function (strProp) {
                if (self.sliderArgs.hasOwnProperty(strProp)) {
                    normalArgs[strProp] = self.sliderArgs[strProp];
                }
            });

            return normalArgs;

        };

        /**
         * Init method
         * @param  {sliderArgs}  arguments for the slider object passed from obj def
         * @return {boolean - false if slider element ID doesn't exist}
         */
        self.init = function () {

            if (!document.getElementById(self.sliderArgs.target)) {
                return false;
            }

            self.buildSlider();

            if (wtm.debug_mode) console.log('> Slider factory loaded;');
        };

        return self.init();
    };

});
